export default __webpack_public_path__ + "static/media/Jewelre Logo Trans.png (1).12de2b99.png";